export enum ActionFilterKey {
  Categories = 'Categories',
  Services = 'Services',
  Companies = 'Companies',
  Sites = 'Sites',
}
